/**
 * Claude's ruling 2 (13 Oct; DCTA-198 item 1, docs/specs/fe-audio-evidence-dcta191.md Change 3): what the customer is told
 * about the spoken turn's audio the bank keeps (ADR-0024) — once a session under the composer, the first time the
 * microphone is used with the engine that keeps a clip, and always in Me › Privacy. No modal, no extra tap.
 */
export const VOICE_CONSENT = "Voice clips are kept for 24 hours as proof of what you asked.";
